import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import qs from "qs";
import { ClubMedia } from "../Lib";

export const clubsMediaDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    update: async ({
      variables,
    }: {
      id: number;
      resource: string;
      variables: ClubMedia;
    }) => {
      const updateUrl = "/cms/team/updateMedia";

      try {
        const { data } = await httpClient.post(updateUrl, {
          ...variables,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({
      resource,
      variables,
    }: {
      resource: string;
      variables: ClubMedia;
    }) => {
      const updateUrl = "/cms/team/addMedia";

      try {
        const { data } = await httpClient.post(updateUrl, {
          ...variables,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ resource, id, meta }) => {
      const url = "/cms/team/removeMedia";

      try {
        const { data } = await httpClient.post(
          `${url}?${qs.stringify({ mediaId: id })}`
        );
        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
